<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'通知情報' | translate}}</h1>

  <div class="long-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="mark()" [disabled]="!selection.selected.length">
      <mat-icon>drafts</mat-icon>
      <span>{{'既読にする' | translate}}</span>
    </button>
    <button mat-raised-button color="primary" (click)="unmark()" [disabled]="!selection.selected.length">
      <mat-icon>mail</mat-icon>
      <span>{{'未読に戻す' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
  <mat-form-field fxFlex="15%">
    <mat-select placeholder="{{'通知種別' | translate}}" id="type" (selectionChange)="applyFilterType($event)">
      <mat-option *ngFor="let noticeType of noticeTypes" [value]="noticeType.type">
        {{ noticeType.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-checkbox class="filter-checkbox" (change)="applyFilterConfirmed($event)">{{'未読のみ' |
    translate}}</mat-checkbox>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> {{'No.' | translate}} </th>
      <td mat-cell *matCellDef="let notice; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()">
        </mat-checkbox>
        <span>{{'全' | translate}}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'通知種別' | translate}} </th>
      <td mat-cell *matCellDef="let notice">
        <mat-icon *ngIf="notice.notice_type=='info'" class="material-icons color_info">info</mat-icon>
        <mat-icon *ngIf="notice.notice_type=='warn'" class="material-icons color_warn">warning</mat-icon>
        <mat-icon *ngIf="notice.notice_type=='err'" class="material-icons color_err">error</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'日時' | translate}} </th>
      <td mat-cell *matCellDef="let notice"> {{ notice.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'タイトル' | translate}} </th>
      <td mat-cell *matCellDef="let notice">
        <mat-icon *ngIf="!isConfirmed(notice)" class="material-icons color_gold">new_releases</mat-icon>
        {{ notice.notice_title }}
      </td>
    </ng-container>

    <ng-container matColumnDef="detail">
      <th mat-header-cell *matHeaderCellDef> {{'詳細' | translate}} </th>
      <td mat-cell *matCellDef="let notice">
        <button mat-button color="primary" (click)="openDetailDialog(notice)">
          <mat-icon>search</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>